export const LOAD_TABS = "LOAD_TABS";
export const LOAD_TABS_SUCCESS = "LOAD_TABS_SUCCESS";
export const LOAD_TABS_FAIL = "LOAD_TABS_FAIL";
export const SUBMIT_TAB = "SUBMIT_TAB";

export default function tab(
  state = {
    data: [],
    loading: true,
    hasError: false,
  },
  action,
) {
  switch (action.type) {
    case LOAD_TABS: {
      return Object.assign({}, state, {
        loading: true,
      });
    }

    case LOAD_TABS_FAIL: {
      return Object.assign({}, state, {
        loading: false,
        hasError: true,
      });
    }

    case LOAD_TABS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        loading: false,
      });
    }
    default:
      return state;
  }
}

export function getTabs() {
  return {
    type: LOAD_TABS,
    payload: {
      request: {
        url: "Tab",
      },
    },
  };
}

export function addTab(tab) {
  return {
    type: SUBMIT_TAB,
    payload: {
      request: {
        url: "Tab",
        method: "POST",
        data: tab,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getTabs());
        },
      },
    },
  };
}

export function editTab(tab, id) {
  return {
    type: SUBMIT_TAB,
    payload: {
      request: {
        url: "Tab/" + id,
        method: "PUT",
        data: tab,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getTabs());
        },
      },
    },
  };
}
export function deleteTab(id) {
  return {
    type: SUBMIT_TAB,
    payload: {
      request: {
        url: "Tab/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getTabs());
        },
      },
    },
  };
}
